import { render, staticRenderFns } from "./HoverPopupCoupling.vue?vue&type=template&id=18a4a922&scoped=true"
import script from "./HoverPopupCoupling.vue?vue&type=script&lang=js"
export * from "./HoverPopupCoupling.vue?vue&type=script&lang=js"
import style0 from "./HoverPopupCoupling.vue?vue&type=style&index=0&id=18a4a922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4a922",
  null
  
)

export default component.exports